import type { Container } from 'pixi.js';
import { getBoosterUnlockedAtLevel } from '../boosters/getBoosterUnlockedAtLevel';
import { GAME_ECONOMY_SETTINGS } from '../GameConstants';
import { GoalPreviewOverlayView } from '../views/overlays/GoalPreviewOverlayView';
import type { AppStateController } from '../../app/state/AppStateController';
import type { LevelTasksTracker } from '../tasks/LevelTasksTracker';
import type { BoosterPanelView } from '../BoosterPanelView';
import type { PopupStackController } from '../../popups/PopupStackController';

interface ShowPreLevelOverlaysConfig {
  state: AppStateController;
  popups: PopupStackController;
  tasksTracker: LevelTasksTracker;
  saveProgress: boolean;
  boosterPanel: BoosterPanelView;
  overlayContainer: Container;
}

export async function showPreLevelOverlays(
  config: ShowPreLevelOverlaysConfig,
  // app: App,
  // options: GameSceneOptions,
  // components: GameSceneComponents,
): Promise<void> {
  const { state, tasksTracker, saveProgress, boosterPanel, overlayContainer } = config;

  const hasLevelProgress = saveProgress && state.hasCurrentLevelProgress();
  const levelNumber = saveProgress ? state.getLevelNumber() : 0;
  const levelAttempted = state.getLevelAttempts() > 0;

  if (!hasLevelProgress) {
    const boosterUnlocked = !levelAttempted && getBoosterUnlockedAtLevel(levelNumber, GAME_ECONOMY_SETTINGS.boosters);

    const boosterButton = boosterUnlocked && boosterPanel.getButton(boosterUnlocked);
    if (boosterButton) boosterButton.enabled = false;

    await new GoalPreviewOverlayView({
      tasks: tasksTracker.tasks,
      levelNumber,
      fadeOutBackground: !boosterUnlocked,
    })
      .props({
        parent: overlayContainer,
      })
      .animateAndDestroy();
  }
}
